module.exports = __webpack_public_path__ + "img/44.40373571.jpg";